import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../../api/axios";
import { ArrowLeft } from "lucide-react";
import { toast } from "react-toastify";
import { formatCurrencyCOP, formatDate } from "../../utils/format";

function EntryDetails() {
  const { id } = useParams();
  const [entry, setEntry] = useState(null);

  useEffect(() => {
    api
      .get(`/entries/${id}`)
      .then((res) => setEntry(res.data))
      .catch(() => toast.error("Error al obtener los detalles de la entrada"));
  }, [id]);

  if (!entry) return <p className="p-6 text-gray-500">Cargando...</p>;

  const totalPurchase = entry.entry_details.reduce(
    (sum, detail) => sum + Number(detail.total_product || 0),
    0,
  );

  return (
    <div className="bg-white p-6 rounded-xl shadow-md">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-3xl font-semibold text-gray-800">
          Detalles de Entrada
        </h2>
        <Link
          to="/entries"
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6"
        >
          <ArrowLeft size={20} />
          Volver a entradas
        </Link>
      </div>
      <div className="mb-6 flex gap-4">
        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Fecha
          </label>
          <input
            type="text"
            value={formatDate(entry.date)}
            readOnly
            className="w-full px-3 py-2 border rounded-md bg-gray-100 text-gray-700"
          />
        </div>

        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Proveedor
          </label>
          <input
            type="text"
            value={entry.supplier?.name}
            readOnly
            className="w-full px-3 py-2 border rounded-md bg-gray-100 text-gray-700"
          />
        </div>

      </div>

      <div className="overflow-x-auto rounded-xl shadow">
        <table className="min-w-full bg-white table-auto">
          <thead>
            <tr className="bg-gray-100 text-gray-700 text-center text-sm uppercase tracking-wider">
              <th className="px-6 py-3">Producto</th>
              <th className="px-6 py-3">Lote</th>
              <th className="px-6 py-3">Invima</th>
              <th className="px-6 py-3">Vencimiento</th>
              <th className="px-6 py-3">Cantidad</th>
              <th className="px-6 py-3">Precio Unitario</th>
              <th className="px-6 py-3">Total</th>
            </tr>
          </thead>
          <tbody className="text-center">
            {entry.entry_details.map((detail, index) => (
              <tr
                key={detail.id}
                className={`border-t ${index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  }`}
              >
                <td className="px-6 py-4">{detail.product?.name || "-"}</td>
                <td className="px-6 py-4">
                  {detail.variant?.batch_number || "-"}
                </td>
                <td className="px-6 py-4">
                  {detail.variant?.invima_code || "-"}
                </td>
                <td className="px-6 py-4">
                  {formatDate(detail.variant?.expiration_date)}</td>
                <td className="px-6 py-4">{detail.quantity}</td>
                <td className="px-6 py-4">{formatCurrencyCOP(detail.unit_price)}</td>
                <td className="px-6 py-4">{formatCurrencyCOP(detail.total_product)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex justify-end mt-5 text-lg font-bold">
        Total de la compra: {formatCurrencyCOP(totalPurchase)}
      </div>
    </div>
  );
}

export default EntryDetails;
